module.exports = __webpack_public_path__ + "img/feeling_blue.f0f2e269.png";